import { LocalStorage, isDefined } from "./utils";
/**
 * A class to support Cross-Site Request Forgery mitigation
 */
var CsrfToken = /** @class */ (function () {
    function CsrfToken() {
    }
    var _a;
    _a = CsrfToken;
    /**
     * Generates and stores a randomized state token
     * @returns a randomized string
     */
    CsrfToken.generateStateToken = function () {
        var buf = new Uint32Array(1);
        window.crypto.getRandomValues(buf);
        var token = (buf[0] * new Date().getMilliseconds()).toString();
        _a.storeToken(token);
        return token;
    };
    /**
     * Validates if the state token retunred from the authorization
     * server matches token in local storage
     *
     * @param token - The state token returned from the authorization server
     * @returns A boolean that indicates whether the state token is valid or invalid
     */
    CsrfToken.isValidStateToken = function (token) {
        var storedToken = _a.getTokenFromStorage();
        return isDefined(storedToken) && token === storedToken;
    };
    /**
     * Retrieves the state token from local storage
     * @returns The state token string
     */
    CsrfToken.getTokenFromStorage = function () {
        return LocalStorage.getItem("state");
    };
    /**
     * Stores the state token in local storage
     * @param token The state token string
     */
    CsrfToken.storeToken = function (token) {
        LocalStorage.setItem("state", token);
    };
    return CsrfToken;
}());
export { CsrfToken };
